"use client"

export function ImagePlaceholder() {
  return (
    <div className="relative h-64 w-full bg-gray-700 rounded-md flex items-center justify-center text-gray-400">
      Placeholder Image
    </div>
  )
}
